import * as yup from "yup";
import { fieldAtLeastOneRequired } from "../../../../../common/infrastructure/helpers/yupHelper";

export const BULK_DELETE_CONFIRMATION_WORD = "потвърждавам";

export const bulkDeleteUserEventsFormSchema = yup
  .object({
    userEventIds: yup
      .array()
      .of(yup.number().required())
      .min(1, fieldAtLeastOneRequired("резервация"))
      .required(),
    confirmationWord: yup
      .string()
      .required()
      .test(
        "matches-confirmation-word",
        `Моля изпишете думата "${BULK_DELETE_CONFIRMATION_WORD}" в полето по-долу.`,
        (value) =>
          (value ?? "").trim().toLowerCase() === BULK_DELETE_CONFIRMATION_WORD,
      ),
  })
  .required();

export type IBulkDeleteUserEventsFormModel = yup.InferType<
  typeof bulkDeleteUserEventsFormSchema
>;

export const bulkDeleteUserEventsFormDefaultValues: IBulkDeleteUserEventsFormModel =
  {
    userEventIds: [],
    confirmationWord: "",
  };
